import { render } from "./GeneralExcel.vue?vue&type=template&id=20dbc926&scoped=true"
import script from "./GeneralExcel.vue?vue&type=script&lang=js"
export * from "./GeneralExcel.vue?vue&type=script&lang=js"

import "./GeneralExcel.vue?vue&type=style&index=0&id=20dbc926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dbc926"]])

export default __exports__